import { render, staticRenderFns } from "./PersonalReport.vue?vue&type=template&id=51d810c7"
import script from "./PersonalReport.vue?vue&type=script&lang=js"
export * from "./PersonalReport.vue?vue&type=script&lang=js"
import style0 from "./PersonalReport.vue?vue&type=style&index=0&id=51d810c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports